// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TestimonialVideo__container___3X21c{width:694px;margin:64px auto 90px}@media (max-width:959px){.TestimonialVideo__container___3X21c{margin:0 0 80px}}.TestimonialVideo__videoContainer___vBk5Q{width:100%;height:100%;padding-top:32px}.TestimonialVideo__videoContainer___vBk5Q iframe{width:694px;height:390px}@media (max-width:959px){.TestimonialVideo__videoContainer___vBk5Q{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "TestimonialVideo__container___3X21c",
	"videoContainer": "TestimonialVideo__videoContainer___vBk5Q"
};
module.exports = ___CSS_LOADER_EXPORT___;
